import React, { useEffect } from "react";
import { usePaymentCore } from "@/features/payment";
import { LoadingSpinner } from "@/components/common/loading-spinner";
import { useTranslation } from "react-i18next";

export const PaymentRedirectingPage: React.FC = () => {
  const { sessionId, sessionUrl } = usePaymentCore();
  const { t } = useTranslation();

  // Eğer sessionUrl varsa, kısa bir gecikme ile Stripe'a yönlendir
  useEffect(() => {
    if (sessionUrl) {
      const timer = setTimeout(() => {
        window.location.href = sessionUrl;
      }, 2000); // 2 saniye gecikme

      return () => clearTimeout(timer);
    }
  }, [sessionUrl]);

  return (
    <div className="flex flex-col items-center justify-center p-8 text-center">
      <div className="mb-6">
        <LoadingSpinner size="lg" />
      </div>

      <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
        {t("payment.redirecting")}
      </h2>

      <p className="text-gray-600 dark:text-gray-400 mb-6 max-w-md">
        {t("payment.redirectingDescription")}
      </p>

      <div className="flex items-center space-x-2 text-sm text-gray-500 dark:text-gray-400">
        <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></div>
        <span>{t("payment.secureConnection")}</span>
      </div>

      {sessionId && (
        <div className="mt-4 text-sm text-gray-500 dark:text-gray-400">
          Session ID: {sessionId}
        </div>
      )}
    </div>
  );
};
